// extracted by mini-css-extract-plugin
module.exports = {"last-week-average-data":"style_last-week-average-data__2Uok5","title":"style_title__3yzCt","data":"style_data__u0Zqp"};